import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from './core/theme/theme.service';
import { Platform } from '@angular/cdk/platform';
import { UserFeedbackState } from 'src/app/core/utilities/user-feedback-state/user-feedback-state';
import { AppVersionService } from './core/services/app-version/app-version.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mvm2';
  userFeedback = new UserFeedbackState();
    constructor(
    private router: Router,
    private themeService: ThemeService,
    private platform: Platform,
    private appVersionService: AppVersionService
    ) {
      // Preserve the saved theme and onboarding draft across the storage reset below
      let savedTheme: string | null = null;
      let savedDraft: string | null = null;
      try {
        savedTheme = localStorage.getItem(ThemeService.THEME_STORAGE_KEY);
        savedDraft = localStorage.getItem('vm_onboarding_draft');
      } catch (e) {}
      localStorage.clear();
      try {
        if (savedTheme) {
          localStorage.setItem(ThemeService.THEME_STORAGE_KEY, savedTheme);
        }
        if (savedDraft) {
          localStorage.setItem('vm_onboarding_draft', savedDraft);
        }
      } catch (e) {}

        // Initialize theme immediately on bootstrap (Light Mode by default, or saved preference)
        this.themeService.initializeTheme();

        // Applies the shared cookie preference when present, otherwise the
        // locally saved preference, otherwise Light Mode.
        let data = document.cookie.split('; ').find((row) => row.startsWith('myObjectCookie='));
        if(data){
          const cookieValue = data.split('=')[1];
          const myObjectCookie = JSON.parse(cookieValue);
          const themeValue = myObjectCookie.theme;
          this.handleMessage(themeValue);
        } else if (savedTheme) {
          this.handleMessage(savedTheme === 'dark');
        }
        this.router.events.subscribe((e) => {
          if (e instanceof NavigationEnd) {
            this.themeService.initializeTheme();
          }
          window.scrollTo(0, 0);
        })
        if (this.platform.IOS) {
          document.body.style.setProperty('-webkit-overflow-scrolling', 'none');
      }
        this.appVersionService.start();
        }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event && event.data) {
      if (event.data.type === 'darkModeStatus' && typeof event.data.value === 'boolean') {
        this.handleMessage(event.data.value);
      } else if (typeof event.data.theme === 'boolean') {
        this.handleMessage(event.data.theme);
      }
    }
  }

  handleMessage(message: any) {
    if (message === true) {
      this.themeService.toggleDarkTheme(true);
    } else if (message === false) {
      this.themeService.toggleDarkTheme(false);
    }
  }
}
